import { gql } from '@apollo/client';
import { Box, HStack } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';
import { CellProps } from 'react-table';
import { DisplaySyncStatus } from '~components/displays/DisplaySyncStatus';
import { DisplayTable_DisplayFragment } from '../__generated__/DisplayTableServerSide.graphql';
import { ConfigurationCell_DisplayFragment } from './__generated__/ConfigurationCell.graphql';

// The configuration actions (assign / unassign / import) live in the row's "⋮" menu — see
// RowActionsCell.
export function ConfigurationCell({
  value,
}: PropsWithChildren<CellProps<DisplayTable_DisplayFragment, ConfigurationCell_DisplayFragment>>) {
  return (
    <HStack gap={2}>
      <Box
        overflow="hidden"
        textOverflow="ellipsis"
        whiteSpace="nowrap"
        color={'gray.500'}
        fontWeight="semibold"
        maxW={150}
      >
        {value.configuration?.name}
      </Box>
      {value.configurationSyncStatus && (
        <Box maxW={'200px'}>
          <DisplaySyncStatus syncStatus={value.configurationSyncStatus} />
        </Box>
      )}
    </HStack>
  );
}

ConfigurationCell.graphql = {
  fragments: {
    ConfigurationCell_display: gql`
      fragment ConfigurationCell_display on Display {
        id
        alias
        configuration {
          id
          name
        }
        configurationSyncStatus
      }
    `,
  },
};
